import React from 'react';
import { ShieldCheckIcon, LightBulbIcon, AcademicCapIcon, CheckBadgeIcon } from '@heroicons/react/24/outline';
export function Mission() {
  const goals = [{
    icon: ShieldCheckIcon,
    title: 'Stay secure online',
    description: 'Protect yourself and your business from cyber threats'
  }, {
    icon: CheckBadgeIcon,
    title: 'Choose the right software with confidence',
    description: 'Make informed decisions backed by expert testing and reviews'
  }, {
    icon: LightBulbIcon,
    title: 'Understand emerging technologies without the jargon',
    description: 'Learn about AI, cloud computing, and new tech in simple terms'
  }, {
    icon: AcademicCapIcon,
    title: 'Make informed choices in a rapidly changing digital world',
    description: 'Stay ahead with knowledge that matters'
  }];
  return <section className="w-full py-20 px-6 bg-gradient-to-br from-blue-50 to-indigo-100" data-id="element-87">
      <div className="max-w-6xl mx-auto" data-id="element-88">
        <h2 className="text-4xl font-bold text-gray-900 mb-6 text-center" data-id="element-89">
          Our Mission
        </h2>
        <p className="text-xl text-gray-700 leading-relaxed mb-4 text-center max-w-3xl mx-auto" data-id="element-90">
          Our mission is simple yet powerful:
        </p>
        <p className="text-2xl font-semibold text-blue-600 mb-12 text-center" data-id="element-91">
          To make technology safer, smarter, and easier for everyone.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed mb-12 text-center max-w-3xl mx-auto" data-id="element-92">
          We aim to help individuals and businesses navigate the digital
          landscape with confidence:
        </p>
        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-93">
          {goals.map((goal, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md" data-id="element-94">
              <goal.icon className="w-10 h-10 text-blue-600 mb-4" data-id="element-95" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-96">
                {goal.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-97">
                {goal.description}
              </p>
            </div>)}
        </div>
        <p className="text-lg text-gray-700 leading-relaxed text-center max-w-3xl mx-auto" data-id="element-98">
          At SoftwarePair.com, we don't just follow trends — we break them down,
          simplify them, and turn them into practical knowledge you can use.
          Whether you're looking to secure your business, find the perfect
          productivity tool, or simply understand what's happening in the world
          of technology, we're here to guide you every step of the way.
        </p>
      </div>
    </section>;
}